import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["groupCheckbox", "participantsSelect", "chatNameContainer", "hiddenChatName"]
  
  connect() {
    // Initialiser le nom du chat basé sur le participant sélectionné
    this.updateChatName()
    // Appliquer l'état initial
    this.toggleGroupChat()
  }
  
  toggleGroupChat() {
    const isGroup = this.groupCheckboxTarget.checked
    const selectElement = this.participantsSelectTarget
    selectElement.name = 'chat_room[user_ids][]'

    if (isGroup) {
      selectElement.setAttribute('multiple', 'multiple')
      this.chatNameContainerTarget.classList.remove('hidden')
    } else {
      selectElement.removeAttribute('multiple')
      this.chatNameContainerTarget.classList.add('hidden')
      this.updateChatName()
    }
  }
  
  updateChatName() {
    if (!this.participantsSelectTarget.multiple) {
      const selectedOption = this.participantsSelectTarget.options[this.participantsSelectTarget.selectedIndex]
      const selectedUserName = selectedOption ? selectedOption.text : ''
      this.hiddenChatNameTarget.value = selectedUserName
    }
  }
}
